"use strict";

exports.__esModule = true;
exports.default = dummy;
function dummy(context) {
    var buffer = context.createBuffer(1, 1, context.sampleRate);
    var source = context.createBufferSource();
    source.buffer = buffer;
    source.connect(context.destination);
    source.start(0);
    source.stop(0);
    source.disconnect();
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/sono/core/utils/dummy.js
// module id = 151
// module chunks = 0